"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const styles_1 = require("../../../styles");
var SideType;
(function (SideType) {
    SideType["Left"] = "LEFT";
    SideType["Right"] = "RIGHT";
    SideType["Center"] = "CENTER";
})(SideType || (SideType = {}));
var PositionType;
(function (PositionType) {
    PositionType["Top"] = "TOP";
    PositionType["Bottom"] = "BOTTOM";
})(PositionType || (PositionType = {}));
const defaultProps = {};
const initialState = {
    position: PositionType.Bottom,
    side: SideType.Center,
};
const getPosition = (props) => {
    switch (props.position) {
        case PositionType.Top:
            return 'bottom: calc(100% + 6px);';
        default:
            return 'top: calc(100% + 6px);';
    }
};
const getSide = (props) => {
    switch (props.side) {
        case SideType.Left:
            return 'left: 0;';
        case SideType.Right:
            return 'right: 0;';
        default:
            return 'left: calc(50% - 6px);transform: translateX(-50%);';
    }
};
const getArrowSide = (props) => {
    switch (props.side) {
        case SideType.Left:
            return 'left: 1rem;';
        case SideType.Right:
            return 'right: 1rem;';
        default:
            return 'left: 50%;';
    }
};
const getArrowPosition = (isBefore) => (props) => {
    switch (props.position) {
        case PositionType.Top:
            return `bottom: ${isBefore ? '-10px' : '-9px'};border-top: 6px solid ${isBefore ? 'rgba(137, 157, 166, 0.35)' : styles_1.Colors.White};`;
        default:
            return `top: ${isBefore ? '-4px' : '-3px'};border-bottom: 6px solid ${isBefore ? 'rgba(137, 157, 166, 0.35)' : styles_1.Colors.White};`;
    }
};
const Container = (0, styled_components_1.default)('div') `
  background: ${styles_1.Colors.White};
  position: absolute;
  ${getPosition};
  ${getSide};
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(137, 157, 166, 0.35);
  border-radius: 3px;
  padding: 0.5rem;
  white-space: nowrap;
  &:before {
    position: absolute;
    content: '';
    ${getArrowPosition(true)}
    ${getArrowSide};
    transform: translateY(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
  }
  &:after {
    position: absolute;
    content: '';
    ${getArrowPosition(false)}
    ${getArrowSide};
    transform: translateY(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
  }
`;
class MenuWrapper extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = initialState;
        this.handleRef = (element) => {
            if (element) {
                const childRect = element.getBoundingClientRect();
                let position = PositionType.Bottom;
                let side = SideType.Center;
                if (childRect.top + childRect.height >= window.innerHeight) {
                    position = PositionType.Top;
                }
                if (childRect.left < 0) {
                    side = SideType.Left;
                }
                if (childRect.right > window.innerWidth) {
                    side = SideType.Right;
                }
                this.setState({
                    position,
                    side,
                });
            }
        };
    }
    render() {
        const { position, side } = this.state;
        return (react_1.default.createElement(Container, { side: side, position: position },
            react_1.default.createElement("div", { ref: this.handleRef }, this.props.children)));
    }
}
exports.default = MenuWrapper;
MenuWrapper.defaultProps = defaultProps;
